import {
  CHANGE_ACTIVE_ITEM_HOME,
  CHANGE_ACTIVE_ITEM_RESUME,
  CHANGE_ACTIVE_ITEM_LIVELIST,
  CHANGE_ACTIVE_ITEM_LIVELIST_MATRIX,
  CHANGE_ACTIVE_ITEM_GRAPHIC_TOPOLOGY,
  CHANGE_ACTIVE_ITEM_OPTIC_FIBER,
  CHANGE_ACTIVE_ITEM_OPTIC_FIBER_LOG,
  CHANGE_ACTIVE_ITEM_TAG,
  CHANGE_ACTIVE_ITEM_LOG,
  CHANGE_ACTIVE_ITEM_CONFIG,
  SOLVE_PROBLEM,
} from "../actions/types";

export function activeMenuItemReducer(initialState = { activeItem: "/" }, action) {
  switch (action.type) {
    case CHANGE_ACTIVE_ITEM_HOME:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_RESUME:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_LIVELIST:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_LIVELIST_MATRIX:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_GRAPHIC_TOPOLOGY:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_OPTIC_FIBER:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_OPTIC_FIBER_LOG:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_TAG:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_LOG:
      return action.payload.activeItem;
    case CHANGE_ACTIVE_ITEM_CONFIG:
      return action.payload.activeItem;
    default:
      return initialState;
  }
}

export function solveProblemReducer(initialState = { solve: false, problem: {} }, action) {
  switch (action.type) {
    case SOLVE_PROBLEM:
      return action.payload;
    default:
      return initialState;
  }
}